import axios from "axios";

const api_base_url = process.env.REACT_APP_API_BASEURL + "/ProducerCode";

export const getCDRCStatusReconciliationFindings = async (
  batchId: number,
): Promise<string[]> => {
  const response = await axios.get<string[]>(
    `${api_base_url}/CDRCStatusReconciliation/Findings/${batchId}`,
  );

  return response.data;
};
